<template>
  <div class="wh100">
    <el-row :gutter="gutter" :style="{marginBottom:marginVal,height:firstRowHeight}">
      <el-col :span="span[0]">
        <slot name="lt"></slot>
      </el-col>
      <el-col :span="span[1]">
        <slot name="rt"></slot>
      </el-col>
    </el-row>
    <el-row :gutter="gutter" :style="{height:secondRowHeight}">
      <el-col :span="span[2]">
        <slot name="lb"></slot>
      </el-col>
      <el-col :span="span[3]">
        <slot name="rb"></slot>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "layoutcorner",
  props: {
    height: {
      type: Array,
      default: function() {
        return [50, 50];
      }
    },
    span: {
      type: Array,
      default: function() {
        return [12, 12, 12, 12];
      }
    },
    gutter: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    marginVal: function() {
      return this.gutter + "px";
    },
    firstRowHeight: function() {
      let half = this.gutter / 2;
      let marginVal = half + "px";
      return "calc(" + this.height[0] + "% - " + marginVal + ")";
    },
    secondRowHeight: function() {
      let half = this.gutter / 2;
      let marginVal = half + "px";
      return "calc(" + this.height[1] + "% - " + marginVal + ")";
    }
  }
};
</script>
<style lang="less" scoped>
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  height: 100%;
}
</style>